import { recruitmentProcess } from "../components/Roles/CreateRole/CreateRoleForm";
import { APIURL } from "./config";

export const getRoleWorkflows = async (token: string) => {
  const res = await fetch(`${APIURL}/RoleWorkflow`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const json = await res.json();
  return json;
};

export const getWorkFlowStatuses = async (roleWorkflowId: string, token: string) => {
  const res = await fetch(`${APIURL}/RoleWorkflow/${roleWorkflowId}/statuses`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const json = await res.json();
  return json;
};

export const postWorkflowAndStatuses = async (
  workFlowName: string,
  process: recruitmentProcess[],
  token: string
) => {
  await fetch(`${APIURL}/RoleWorkflow`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      workFlowName,
      roleWorkflowStatuses: process,
    }),
  });
};

export const updateWorkflowAndStatuses = async (
  workflowId: string,
  workFlowName: string,
  process: recruitmentProcess[],
  token: string
) => {
  try {
    await fetch(
      `${APIURL}/RoleWorkflow/${workflowId}?workflowName=${workFlowName}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(process),
      }
    );
  } catch (err) {
    console.error("Error updating workflow:", err);
  }
};

export const deleteWorkflow = async (workflowid: string, token: string) => {
  await fetch(`${APIURL}/RoleWorkflow/${workflowid}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
